import Hero from 'components/AboutUs/Hero';
import AboutUsSection from 'components/AboutUs/AboutUsSection';
import AutolistModel from 'components/AboutUs/AutolistModel';
import WhoWeAre from 'components/AboutUs/WhoWeAre';
import TeamCarousel from 'components/AboutUs/TeamCarousel';
import JoinUsHero from 'components/AboutUs/JoinUsHero';
import JoinUsDescription from 'components/AboutUs/JoinUsDescription';
import Montage from 'components/AboutUs/Montage';
import CurrentOpenings from 'components/AboutUs/CurrentOpenings';

const AboutUs = () => (
  <>
    <Hero />
    <AboutUsSection />
    <AutolistModel />
    <WhoWeAre />
    <TeamCarousel />
    <JoinUsHero />
    <JoinUsDescription />
    <Montage />
    <CurrentOpenings />
  </>
);

export default AboutUs;
